import styled from 'styled-components';
import { motion } from 'framer-motion';

// Auth Page wrapper with gradient background
// Uses 100svh for mobile browser correctness (avoids address bar issues)
export const AuthPage = styled.div`
  min-height: 100svh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: clamp(16px, 3vh, 32px);
  padding-bottom: clamp(16px, 3vh, 32px);
  padding-left: 1rem;
  padding-right: 1rem;
  background: radial-gradient(circle at top, rgba(176,141,87,0.16), transparent 55%),
              linear-gradient(180deg, var(--background-secondary), var(--background-primary));
  overflow-y: auto;
  
  @media (max-width: 768px) {
    padding-top: clamp(12px, 2vh, 24px);
    padding-bottom: clamp(12px, 2vh, 24px);
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

// Auth Card container - Modern rounded aesthetic
export const AuthCard = styled(motion.div)`
  background: var(--surface-color, var(--background-primary));
  border: 1px solid var(--border-color);
  border-radius: 18px;
  box-shadow: var(--shadow-md);
  padding: 2.5rem;
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
    border-radius: 16px;
  }
  
  @media (max-width: 480px) {
    border-radius: 14px;
  }
`;

// Optional Auth Header component for consistent header styling
export const AuthHeader = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;
  
  h1, h2 {
    color: var(--text-primary);
    font-family: 'Inter', sans-serif;
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0 0 0.5rem 0;
    
    @media (max-width: 768px) {
      font-size: 1.25rem;
    }
  }
  
  p {
    color: var(--text-muted);
    font-size: 0.875rem;
    margin: 0;
  }
`;

